export default "/img/SN.e006c80e24142c5513f504d51e3e775e.png";